/**
 * Dashboard-family badge displayed on facility configuration cards.
 */

import { ConfigSectionType } from "../../../../../../../shared/enums/rbacRoles";

const CHIP_CONFIG: Record<
  ConfigSectionType,
  { label: string; className: string }
> = {
  med_onc: {
    label: "MedOnc",
    className: "bg-tertiaryBlue-12 text-tertiaryBlue-4",
  },
  pharmacy: {
    label: "Pharmacy",
    className: "bg-statusGreen-bg text-statusGreen-text",
  },
  claims: {
    label: "Claims",
    className: "bg-secondaryPurple-9 text-secondaryPurple-4",
  },
  clinical_trials: {
    label: "Clinical Trials",
    className: "bg-tertiaryBlue-11 text-tertiaryBlue-3",
  },
};

/**
 * Small colored pill identifying which dashboard a facility belongs to.
 * Renders nothing when the dashboardType is missing or unrecognized.
 */
const DashboardTypeChip = ({
  dashboardType,
}: {
  dashboardType?: ConfigSectionType;
}) => {
  const config = dashboardType ? CHIP_CONFIG[dashboardType] : undefined;
  if (!config) return null;

  return (
    <span
      className={`rounded-full px-2 py-0.5 text-tiny font-semibold ${config.className}`}
    >
      {config.label}
    </span>
  );
};

export default DashboardTypeChip;
